import { Controller } from "@hotwired/stimulus";

// use this to rename a click or event from another controller
export default class extends Controller {
  static values = { name: String, newName: String }

  connect() {
    this.boundRetrigger = this.retrigger.bind(this)
    $(this.element).on(this.nameValue, this.boundRetrigger)
  }

  disconnect() {
    $(this.element).off(this.nameValue, this.boundRetrigger)
  }

  retrigger() {
    this.dispatch(this.newNameValue, {
      details: { renamed: true },
      prefix: false
    })
  }
}
